export const dataDefault = [{
    sort: 0,
    des: "",
    qty: 0,
    cost: 0,
    price: 0,
    total_cost: 0,
    total_sales: 0,
    percent: 0
}, {
    sort: 1,
    des: "",
    qty: 0,
    cost: 0,
    price: 0,
    total_cost: 0,
    total_sales: 0,
    percent: 0
}, {
    sort: 2,
    des: "",
    qty: 0,
    cost: 0,
    price: 0,
    total_cost: 0,
    total_sales: 0,
    percent: 0
}, {
    sort: 3,
    des: "",
    qty: 0,
    cost: 0,
    price: 0,
    total_cost: 0,
    total_sales: 0,
    percent: 0
}, {
    sort: 4,
    des: "",
    qty: 0,
    cost: 0,
    price: 0,
    total_cost: 0,
    total_sales: 0,
    percent: 0
}, {
    sort: 5,
    des: "",
    qty: 0,
    cost: 0,
    price: 0,
    total_cost: 0,
    total_sales: 0,
    percent: 0
}, {
    sort: 6,
    des: "",
    qty: 0,
    cost: 0,
    price: 0,
    total_cost: 0,
    total_sales: 0,
    percent: 0
}, {
    sort: 7,
    des: "",
    qty: 0,
    cost: 0,
    price: 0,
    total_cost: 0,
    total_sales: 0,
    percent: 0
}, {
    sort: 8,
    des: "",
    qty: 0,
    cost: 0,
    price: 0,
    total_cost: 0,
    total_sales: 0,
    percent: 0
}, {
    sort: 9,
    des: "",
    qty: 0,
    cost: 0,
    price: 0,
    total_cost: 0,
    total_sales: 0,
    percent: 0
}];


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-8/5-8-2/data.js